import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AppConfig } from '../app-config.loader';
import { CisAllegato } from '../shared/models/cisAllegato.model';
import { RegistriRequest, RegistriResponse, RegistroAllegatiCIS, RegistroCarico, RegistroCategoria, RegistroDistruzioni, RegistroProtocollo, RegistroRiproduzioni, RegistroUnico } from '../shared/models/registriRequest.model';
import { RegistroColumn } from '../shared/models/registro-column.model';

@Injectable({
  providedIn: 'root'
})
export class RegistriService {
  public colsProtocollo: RegistroColumn[] = [
    { field: 'progressivo', header: 'Progr.', width: '50px', align: 'right' },
    { field: 'registroData', header: 'Data protocollo', width: '85px', align: 'center', pipe: 'Date' },
    { field: 'arrPart', header: 'Arr/ Part', width: '36px', align: 'center' },
    { field: 'mittDest', header: 'Mittente/Destinatario', width: '265px', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'dataNumeroAtto', header: 'Data e numero dell\'atto', align: 'center', width: '150px', pipe: 'ReplaceTilde', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'oggetto', header: 'Oggetto', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'posizioneArchivio', header: 'Posizione d\'archivio', width: '265px', pipe: 'ReplaceTilde', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'annotazioni', header: 'Annotazioni', width: '265px', pipe: 'HighlightDistrutto', fontSize: RegistriConstants.FONT_SMALL }
  ];

  public colsRiproduzioni: RegistroColumn[] = [
    { field: 'numeroOrdine', header: 'N. ordine', width: '50px', align: 'right' },
    { field: 'dataRichiesta', header: 'Data', width: '75px', align: 'center', pipe: 'Date' },
    { field: 'richiedente', header: 'Nominativo', pipe: 'ReplaceTilde', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'protocollo', header: 'Numero di protocollo o di controllo', align: 'center', width: '175px' },
    { field: 'dataProtocollazione', header: 'Data', width: '75px', align: 'center', pipe: 'Date' },
    { field: 'classificaQualifica', header: 'Qual. e Class.', width: '55px', align: 'center' },
    { field: 'numeroPagine', header: 'Num. pag.', width: '45px', align: 'center', pipe: 'ReplaceTilde' },
    { field: 'numeroCopie', header: 'Numero copie eseguite', width: '60px', align: 'center' },
    { field: 'firma1', header: 'Firma del ricevente', pipe: 'Trasmesso', width: '98px', align: 'center', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'funzionarioDiControllo', header: 'Firma del Funzionario di controllo o suo sostituto', width: '105px', align: 'center', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'annotazioni', header: 'Annotazioni', width: '265px', fontSize: RegistriConstants.FONT_SMALL }
  ];

  public colsUnicoControllo: RegistroColumn[] = [
    { field: 'numeroOrdine', header: 'N. ordine', width: '50px', align: 'right' },
    { field: 'qualificaClassifica', header: 'Classifica e Qualifica', width: '90px', align: 'center' },
    { field: 'dataProtocollazione', header: 'Data', width: '88px', align: 'center', pipe: 'Date' },
    { field: 'lingua', header: 'Lingua', width: '110px' },
    { field: 'numeroCopieEmesse', header: 'Numero di copie emesse', width: '80px', align: 'center' },
    { field: 'distribuzione', header: 'Distribuzione' },
    { field: 'posizioneArchivio', header: 'Posizione d\'archivio', width: '310px' }
  ];

  public colsCarico: RegistroColumn[] = [
    { field: 'numeroOrdine', header: 'N. ordine', width: '50px', align: 'right' },
    { field: 'numeroControllo', header: 'N. di Contr.', width: '50px', align: 'center' },
    { field: 'protocollo', header: 'Numero di protocollo', width: '175px', align: 'center', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'classifica', header: 'Class.', width: '55px', align: 'center' },
    { field: 'dataProtocollazione', header: 'Data del documento', width: '88px', align: 'center', pipe: 'Date' },
    { field: 'lingua', header: 'Lingua', width: '85px' },
    { field: 'esemplariRicevuti', header: 'Numero esemplari originati o ricevuti', width: '75px', align: 'center' },
    { field: 'numeroCopie', header: 'Numero distinto delle copie', width: '75px', align: 'center' },
    { field: 'allegati', header: 'Allegati originati o ricevuti', width: '105px', fontSize: RegistriConstants.FONT_SMALL, pipe: 'ReplaceTilde' },
    { field: 'distribuzione', header: 'Distribuzione', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'copieInCarico', header: 'Copie in carico', width: '50px', align: 'center' },
    { field: 'variazioni', header: 'Variazioni distruzioni', pipe: 'HighlightDistrutto', width: '226px', fontSize: RegistriConstants.FONT_XSMALL },
    { field: 'note', header: 'Note', width: '170px', fontSize: RegistriConstants.FONT_XSMALL }
  ];

  // public colsDistruzioni: RegistroColumn[] = [
  //   { field: 'numeroOrdine', header: 'N. ordine', width: '50px', align: 'right' },
  //   { field: 'registroData', header: 'Data Verbale', width: '88px', align: 'center', pipe: 'Date' },
  //   { field: 'classificaQualifica', header: 'Qualifica e Classifica', width: '110px', align: 'center' },
  //   { field: 'note', header: 'Note' },
  // ];

  public colsDistruzioni: RegistroColumn[] = [
    { field: 'numeroOrdine', header: 'Numero d\'ordine annuale', width: '120px', align: 'right' },
    { field: 'registroData', header: 'Data del Verbale', width: '120px', align: 'center', pipe: 'Date' },
    { field: 'classificaQualifica', header: 'Classifica e qualifica dei documenti distrutti', width: '120px', align: 'center' },
    { field: 'note', header: 'Note (Posizione d\'archivio ecc.)' },
  ];

public colsAllegatiCIS: RegistroColumn[] = [
    { field: 'numeroOrdine', header: 'N. ordine', width: '50px', align: 'right' },
    { field: 'tipoCIS', header: 'Tipo', width: '80px' },
    { field: 'classifica', header: 'Class.', width: '100px', align: 'center' },
    { field: 'SW', header: 'SW', width: '40px', align: 'center', pipe: 'Barred' },
    { field: 'riproduzione', header: 'Riprod.', width: '90px' },
    { field: 'numeroCopie', header: 'N. Copie', width: '50px', align: 'center' },
    { field: 'caricoRicevente', header: 'Ricev.', width: '90px' },
    { field: 'registroData', header: 'Data', width: '80px', align: 'center', pipe: 'Date' },
    { field: 'caricoFirma', header: 'Firma', width: '120px', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'restituzioneData', header: 'Data', width: '80px', align: 'center', pipe: 'Date' },
    { field: 'restituzioneFirma', header: 'Firma', width: '120px', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'distruzioneData', header: 'Data', width: '80px', align: 'center', pipe: 'Date' },
    { field: 'distruzioneFirma', header: 'Firma', width: '120px', fontSize: RegistriConstants.FONT_SMALL },
    { field: 'note', header: 'Note', width: '175px', fontSize: RegistriConstants.FONT_XSMALL },
    { field: 'annotazioni', header: 'Annot.', width: '177px', fontSize: RegistriConstants.FONT_XSMALL, pipe: 'Note' },
];

  private apiBaseUrl: string;

  constructor(appConfig: AppConfig, private http: HttpClient) {
    this.apiBaseUrl = `${appConfig.settings.apiRoot}`;
  }

  public protocollo(request: RegistriRequest): Observable<RegistroProtocollo[]> {
    return this.http.post<RegistroProtocollo[]>(`${this.apiBaseUrl}/registri/protocollo`, request);
  }

  public riproduzioni(request: RegistriRequest): Observable<RegistroRiproduzioni[]> {
    return this.http.post<RegistroRiproduzioni[]>(`${this.apiBaseUrl}/registri/riproduzioni`, request);
  }

  public unicoControllo(request: RegistriRequest): Observable<RegistroUnico[]> {
    return this.http.post<RegistroUnico[]>(`${this.apiBaseUrl}/registri/unicocontrollo`, request);
  }

  public carico(request: RegistriRequest): Observable<RegistroCarico[]> {
    return this.http.post<RegistroCarico[]>(`${this.apiBaseUrl}/registri/carico`, request);
  }

  public distruzioni(request: RegistriRequest): Observable<RegistroDistruzioni[]> {
    return this.http.post<RegistroDistruzioni[]>(`${this.apiBaseUrl}/registri/distruzioni`, request);
  }

  public allegatiCIS(request: RegistriRequest): Observable<CisAllegato[]> {
    return this.http.post<CisAllegato[]>(`${this.apiBaseUrl}/registri/allegaticis`, request)
            .pipe( map(res => {
              this.formattaAnnotazioniCIS(res);
              return res;
            }) );
  }

  public categorie(): Observable<RegistroCategoria[]> {
    return this.http.get<RegistroCategoria[]>(`${this.apiBaseUrl}/registri/categorie`);
  }

  public getByDocumentId(documentId: number): Observable<RegistriResponse> {
    return this.http.get<RegistriResponse>(`${this.apiBaseUrl}/registri/documento/${documentId}`)
            .pipe( map(res => {
              this.formattaAnnotazioniCIS(res.cis);
              return res;
            }) );
  }

  private formattaAnnotazioniCIS(values : CisAllegato[] | RegistroAllegatiCIS[] ): void {
    if ( values) {
      values.forEach( e=> {
        if (!e.annotazioni) {
          e.annotazioni = e.annotazioniUtente;
        } else {
          e.annotazioni = ( e.annotazioniUtente)?`${e.annotazioniUtente} - ${e.annotazioni}`:e.annotazioni;
        }
      });
    }
  }
}

export const RegistriConstants = {
  // REGISTRO DI PROTOCOLLO

  // Numero di righe del registro di protocollo
  ROWS_NUMBER_PROTOCOLLO: 10,
  // Dimensione font standard per il campo Annotazioni
  FONT_DEFAULT: 10,
  // Dimensione font small per il campo Annotazioni
  FONT_SMALL: 9,
  // Dimensione font Xsmall per il campo Annotazioni
  FONT_XSMALL: 8,
  // somma dellle dimensioni di header e footer per il registro di protocollo
  TOTAL_HEADER_FOOTER: 75,
  // massimo numero di caratteri nelle annotazioni del registro protocollo
  MAX_CHAR_ANNOTAZIONI: 150,
  MAX_CHAR_ANNOTAZIONISMALL: 200,
  // massimo numero di caratteri per linea nelle posizioni del registro protocollo
  MAX_CHAR_POSIZIONI: 50,


  // REGISTRI

  // dimensione font intestazione dei registri
  FONT_HEADER: 9,
  // dimensione font small intestazione dei registri
  FONT_HEADER_SMALL: 8,
  // massimo numero di caratteri da visualizzare a font standart nell'header dei registri
  MAX_CHAR_HEADER: 60,

} as const;
